export interface EnvConfig {
  apiUrl: string;
  appEnv: 'development' | 'staging' | 'production';
  isProduction: boolean;
  isDevelopment: boolean;
  zendeskUrl: string;
  autoLoginOnPasswordSet: boolean;
}

export function getEnvConfig(): EnvConfig {
  const appEnv = (import.meta.env.VITE_APP_ENV as EnvConfig['appEnv']) || 'development';

  return {
    apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:3001',
    appEnv,
    isProduction: appEnv === 'production',
    isDevelopment: appEnv === 'development',
    zendeskUrl: import.meta.env.VITE_ZENDESK_URL || 'https://ayuda.delt.ai/hc/es-419/requests/new',
    autoLoginOnPasswordSet: import.meta.env.VITE_AUTO_LOGIN_ON_PASSWORD_SET === 'true',
  };
}
